import { getUserId } from "common/utils/user-context";

// HB-1931: build the Mixpanel event payload for a client-side DTF add-to-cart
// rejection by Orders::DtfAddGuard. submitDtfEvent already injects order_number,
// business_line, current_store_code, catalog_number, and Mixpanel distinct_id —
// so callers only need to provide the rejection-specific properties.
//
// Returns null when the error response is not the guard rejection (success !== false
// or error !== "order_state_invalid"), so the caller can short-circuit without
// emitting unrelated noise.

export type DtfAddBlockedProperties = {
  order_state: string | null;
  source: string;
  page_url: string;
  user_id: string | null;
};

export const DTF_ADD_BLOCKED_EVENT = "dtf_add_blocked_by_order_state";

export const buildDtfAddBlockedProperties = (
  errorResponse: unknown,
  source = "gang_builder_pdp"
): DtfAddBlockedProperties | null => {
  if (!errorResponse || typeof errorResponse !== "object") return null;
  const body = errorResponse as Record<string, unknown>;
  if (body["success"] !== false) return null;
  if (body["error"] !== "order_state_invalid") return null;

  const orderState = body["order_state"];
  return {
    order_state: typeof orderState === "string" ? orderState : null,
    source,
    page_url: typeof window !== "undefined" ? window.location.href : "",
    user_id: getUserId()
  };
};
